// The full-page Record: no sidebar, the RecordTopBar (--topbar-h), then content at full width.
// Top bar markup from design/kit/components/RecordTopBar.
import type { MouseEvent, ReactNode } from 'react';
import { Fragment } from 'react';
import { Link, useNavigate } from 'react-router';
import { ArrowLeftIcon, ChevronRightIcon } from './icons';
import { Bell } from './PageHeader';

export type Crumb = { label: string; to: string };

type RecordLayoutProps = {
  // The page the user came from, then the tab they were on (left out when opened from search).
  crumbs: Crumb[];
  // The insured: the current crumb, not a link.
  current: string;
  // True when the user got here from a page in the portal, so Back can return to it exactly as left.
  cameFromPortal: boolean;
  children: ReactNode;
};

export function RecordLayout({ crumbs, current, cameFromPortal, children }: RecordLayoutProps) {
  const navigate = useNavigate();
  const back = crumbs[0];

  const goBack = (e: MouseEvent) => {
    if (!cameFromPortal) return;
    e.preventDefault();
    navigate(-1);
  };

  return (
    <div className="rpage">
      <header className="rtop">
        <nav className="bc" aria-label="Breadcrumb">
          <Link
            className="bcback"
            to={back.to}
            onClick={goBack}
            aria-label={`Back to ${back.label}`}
          >
            <ArrowLeftIcon className="ico s14" />
          </Link>
          {crumbs.map((c, i) => (
            <Fragment key={c.label}>
              {i > 0 && <ChevronRightIcon className="ico bcs" />}
              <Link className="bcl" to={c.to} onClick={goBack}>
                {c.label}
              </Link>
            </Fragment>
          ))}
          <ChevronRightIcon className="ico bcs" />
          <span className="bcc" aria-current="page">
            {current}
          </span>
        </nav>
        <Bell />
      </header>
      <main className="main">{children}</main>
    </div>
  );
}
